<template>
    <div class="supplier-recruitment-layout">
        <div class="header">
            <div class="header-left">
                <img
                    src="~images/sd_logo.png"
                />
                <span>完善信息申报成为小象超市供应商</span>
            </div>
            <div class="header-right">
                <span>{{ operator }}</span>
                <el-button
                    type="text"
                    @click="__logout"
                >
                    退出
                </el-button>
            </div>
        </div>
        <div class="content">
            <slot name="content">
            </slot>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            operator: '',
        };
    },
    async created() {
        const { login: operator } = await this.__getBizAccount();
        this.operator = operator;
        // 如果是已建立合作关系的供应商，不能进入到招商平台页面
        const { state } = await this.$hPost('/api/vss/shepherd/sqm/merchantsSupplier/getMerchantState');
        if ([999].includes(+state)) {
            this.$tools.linkTo('/index.html');
        }
    },
};
</script>
<style lang="scss" scoped>
.supplier-recruitment-layout {
    height: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    position: relative;
    background: #eee;
    overflow-y: auto;
    .header {
        display: flex;
        flex-direction: row;
        height: 80px;
        align-items: center;
        justify-content: space-between;
        background-color: #fff;
        padding: 10px 10px;
        margin-bottom: 10px;
        .header-left {
            display: flex;
            flex-direction: row;
            img{
                height: 35px;
                margin-top: -1px;
            }
            span {
                font-size: 16px;
                font-weight: bold;
                line-height: 35px;
                margin-left: 10px;
            }
        }
        .header-right {
            padding-right: 10px;
            span {
                font-size: 15px;
            }
        }
    }
    .content {
        padding-top: 30px;
        flex: 1;
        background-color: #fff;
    }
}
</style>
